import { isEqual } from 'lodash';
import React, { FC, useState } from 'react';
import useDeepCompareEffect from 'use-deep-compare-effect';
import { FieldWithValue } from 'api/tasks';
import { Option } from 'components/atoms/select/types';
import { BaseSelect } from 'components/organisms/task-pane/task-detail/task-fields/task-custom-fields/fields/base-select';

interface FieldProps {
  field: FieldWithValue;
  disabled?: boolean;
  onChange?: (selected: number | null, field: FieldWithValue) => void;
}

export const SingleUserField: FC<FieldProps> = ({
  field,
  disabled = false,
  onChange,
}) => {
  const { value } = field;
  const [state, setState] = useState<Option | null>(null);

  useDeepCompareEffect(() => {
    const selected =
      field.metaData?.options?.find((o) => o.value === value) || null;

    setState(selected);
  }, [field]);

  const commit = (selected: Option | null) => {
    setState(selected);
    if (onChange && !isEqual(state, field.value)) {
      onChange(selected ? Number(selected.value) : selected, field);
    }
  };

  return (
    <BaseSelect
      type="user"
      disabled={disabled}
      options={field.metaData?.options}
      value={state}
      onChange={commit}
      data-cy={`right.content.single.user${field.fieldLabel}`}
    />
  );
};
